import React, { useEffect, useRef, useState } from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../../data/mock';

const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 lg:py-32 bg-gradient-to-b from-[#FAF8F5] to-white relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-20 right-10 w-40 h-40 bg-[#E8A5C4]/10 rounded-full blur-2xl" />
      <div className="absolute bottom-20 left-10 w-60 h-60 bg-[#C45B9F]/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="text-[#C45B9F] font-medium uppercase tracking-wider text-sm">
            Témoignages
          </span>
          <h2 className="font-heading text-4xl lg:text-5xl text-[#3D2E35] mt-4">
            Ce que disent nos clients
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`card-tevaite p-8 relative transition-all duration-700 ${
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              {/* Quote icon */}
              <Quote
                className="absolute top-6 right-6 text-[#E8A5C4]/30"
                size={48}
                fill="currentColor"
              />

              {/* Stars */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={18}
                    className="text-[#C4A35A]"
                    fill="currentColor"
                  />
                ))}
              </div>

              {/* Quote text */}
              <p className="text-[#6B5A62] italic leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#E8A5C4] to-[#C45B9F] flex items-center justify-center text-white font-heading text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <p className="font-medium text-[#3D2E35]">{testimonial.name}</p>
                  <p className="text-sm text-[#6B5A62]">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
